import { useMutation, useQuery, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useNoteVersions = (projectId, noteId) =>
  useQuery({
    queryKey: ["note-versions", projectId, noteId],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/projects/${projectId}/notes/${noteId}/versions`,
        signal,
      }),
    select: (response) => {
      const keys = Object.keys(response).reverse();
      if (keys && keys.length) {
        return keys.map((key) => {
          return {
            ...response[key],
            version_id: parseInt(key),
          };
        });
      }
      return [];
    },
  });

export const useNoteVersion = (projectId, noteId, modificationId, config) =>
  useQuery({
    ...config,
    queryKey: ["note-version", noteId, modificationId],
    queryFn: ({ signal }) => {
      return fetch({
        url:
          modificationId > 0
            ? `${Angie.api_url}/projects/${projectId}/notes/${noteId}/compare-to-modification/${modificationId}`
            : `${Angie.api_url}/projects/${projectId}/notes/${noteId}/compare-to-original`,
        signal,
      });
    },
  });

export const useNoteVersionRenameMutation = (projectId, noteId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => {
      if (!data.modification_id) {
        throw new Error("Undefined modification_id passed in data");
      }
      const { modification_id, ...params } = data;
      return fetch({
        url: `${Angie.api_url}/history/note/${noteId}/${modification_id}`,
        method: "PUT",
        body: params,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["note-versions", projectId, noteId]);
    },
  });
};
